// Shared route table used by:
// - src/router/index.js (runtime router)
// - vue.config.js (build-time prerender routes)
// - src/utils/seo-config.js (TDK/SEO config)

module.exports = [
  {
    path: '/',
    redirect: '/index',
    prerender: true,
  },
  {
    path: '/index',
    name: 'HomeView',
    component: () => import('../views/HomeView/HomeView.vue'),
    prerender: true,
    meta: {
      showHeader: true,
      showFooter: true,
      activeMenu: '首页',
      tdk: {
        title: '专业的酒吧霸屏大屏互动点歌软件_松鼠互娱',
        keywords: '酒吧霸屏,大屏互动,扫码点歌,祝福上墙,酒吧游戏',
        description:
          '松鼠互娱是专业的酒吧霸屏大屏互动点歌软件，应用于各类酒吧、餐吧、烧烤吧、音乐餐厅等场所，开启智慧娱乐新体验',
      },
    },
  },
  {
    path: '/cityagent',
    name: 'CityAgentView',
    component: () => import('../views/CityAgentView/CityAgentView.vue'),
    prerender: true,
    meta: {
      showHeader: true,
      showFooter: true,
      activeMenu: '城市代理',
      tdk: {
        title: '酒吧互动软件城市代理招募_松鼠互娱',
        keywords: '酒吧霸屏,扫码点歌,打赏收益,城市代理',
        description:
          '松鼠互娱酒吧霸屏大屏互动点歌软件招募城市代理啦，寻找有资源有渠道的小伙伴，低成本、零风险、高收益，与我们一起开拓广阔蓝海',
      },
    },
  },
  {
    path: '/companyIntroduction',
    name: 'CompanyIntroduction',
    component: () => import('../views/CompanyIntroduction/CompanyIntroduction.vue'),
    prerender: true,
    meta: {
      showHeader: false,
      showFooter: true,
    },
  },
  {
    path: '/ProductIntroduction',
    name: 'ProductIntroduction',
    component: () => import('../views/ProductIntroduction/ProductIntroduction.vue'),
    prerender: true,
    meta: {
      showHeader: false,
      showFooter: true,
    },
  },
  {
    path: '/contactUs',
    name: 'ContactView',
    component: () => import('../views/ContactView/ContactView.vue'),
    prerender: true,
    meta: {
      showHeader: false,
      showFooter: true,
    },
  },
  {
    path: '/help',
    name: 'HelpView',
    component: () => import('../views/HelpView/HelpView.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      activeMenu: '使用帮助',
    },
    children: [
      {
        path: '',
        redirect: 'registerUse',
      },
      {
        path: 'registerUse',
        name: 'RegisterUse',
        component: () => import('../views/HelpView/helps/registerUse.vue'),
        prerender: true,
        meta: {
          tdk: {
            title: '用户注册_用户登录_新手操作手册_松鼠互娱',
            keywords: '注册登录,注册使用,新手使用,酒吧霸屏软件,酒吧互动软件',
            description:
              '松鼠互娱酒吧霸屏软件新用户使用教程，新用户注册登录使用，快速上手，一键开启酒吧智慧娱乐新体验',
          },
        },
      },
      {
        path: 'giftWall',
        name: 'GiftWall',
        component: () => import('../views/HelpView/helps/giftWall.vue'),
        prerender: true,
        meta: {
          tdk: {
            title: '祝福礼物_祝福上墙_微信上墙_松鼠互娱',
            keywords: '祝福上墙,祝福礼物,表白墙,酒吧霸屏软件,酒吧互动软件',
            description: '祝福礼物上墙，在线表白，一键开启土豪专属礼物，就在松鼠互娱酒吧霸屏互动点歌软件',
          },
        },
      },
      {
        path: 'fullscreen',
        name: 'Fullscreen',
        component: () => import('../views/HelpView/helps/fullscreen.vue'),
        prerender: true,
        meta: {
          tdk: {
            title: '照片霸屏_礼物霸屏_重金霸屏_松鼠互娱',
            keywords: '照片霸屏,礼物霸屏,重金霸屏,酒吧霸屏软件,酒吧大屏互动软件',
            description: '照片霸屏，土豪专属重金霸屏，炫酷效果，惊艳全场，就选松鼠互娱酒吧霸屏互动点歌软件',
          },
        },
      },
      {
        path: 'songRequest',
        name: 'SongRequest',
        component: () => import('../views/HelpView/helps/songRequest.vue'),
        prerender: true,
        meta: {
          tdk: {
            title: '微信扫码点歌_酒吧现场点歌_松鼠互娱',
            keywords: '酒吧点歌,微信点歌,扫码点歌,酒吧霸屏软件,酒吧互动软件',
            description: '使用松鼠互娱酒吧霸屏互动点歌软件，微信扫码点歌，方便快捷，一键开启智慧娱乐新体验',
          },
        },
      },
      {
        path: 'reward',
        name: 'Reward',
        component: () => import('../views/HelpView/helps/reward.vue'),
        prerender: true,
        meta: {
          tdk: {
            title: '祝福打赏_打赏歌手_松鼠互娱',
            keywords: '祝福打赏,打赏歌手,土豪打赏,酒吧霸屏软件,酒吧互动软件',
            description: '打赏心爱的歌手，赞赏他的表演，炫酷特效展现，就选择松鼠互娱酒吧霸屏互动点歌软件',
          },
        },
      },
      {
        path: 'lottery',
        name: 'Lottery',
        component: () => import('../views/HelpView/helps/lottery.vue'),
        prerender: true,
        meta: {
          tdk: {
            title: '扫码抽奖_微信头像抽奖_互动抽奖_松鼠互娱',
            keywords: '大屏抽奖,互动抽奖,3D抽奖,活动抽奖,酒吧霸屏软件,酒吧互动软件',
            description:
              '酒吧活动抽奖专用软件，支持3D抽奖、名单抽奖、照片抽奖、微信头像抽奖等多种抽奖方式，就在松鼠互娱酒吧霸屏互动点歌软件',
          },
        },
      },
      {
        path: 'diceStorm',
        name: 'DiceStorm',
        component: () => import('../views/HelpView/helps/diceStorm.vue'),
        prerender: true,
        meta: {
          tdk: {
            title: '酒吧摇骰子游戏_点数风暴游戏_松鼠互娱',
            keywords: '酒吧摇骰子,幸运摇骰子,酒吧霸屏软件,酒吧互动软件',
            description: '极受欢迎的酒吧摇骰子游戏，一键开启幸运骰子，燃爆活动现场，就在松鼠互娱酒吧霸屏互动点歌软件',
          },
        },
      },
      {
        path: 'redPacketRain',
        name: 'RedPacketRain',
        component: () => import('../views/HelpView/helps/redPacketRain.vue'),
        prerender: true,
        meta: {
          tdk: {
            title: '荭包游戏_摇一摇荭包雨_松鼠互娱',
            keywords: '荭包雨,摇荭包,摇一摇荭包雨,酒吧霸屏软件,酒吧互动软件',
            description: '摇一摇荭包雨游戏，让活动更精彩，酒吧氛围升级利器，就在松鼠互娱酒吧霸屏互动点歌软件',
          },
        },
      },
      {
        path: 'shakeGame',
        name: 'ShakeGame',
        component: () => import('../views/HelpView/helps/shakeGame.vue'),
        prerender: true,
        meta: {
          tdk: {
            title: '摇一摇游戏_酒吧摇一摇_松鼠互娱',
            keywords: '摇一摇游戏,赛车摇一摇,酒吧霸屏软件,酒吧互动软件',
            description: '经典赛车摇一摇游戏，参与便捷，玩法有趣，就在松鼠互娱酒吧霸屏互动点歌软件',
          },
        },
      },
      {
        path: 'slideGame',
        name: 'SlideGame',
        component: () => import('../views/HelpView/helps/slideGame.vue'),
        prerender: true,
        meta: {
          tdk: {
            title: '划一划游戏_手机划一划_松鼠互娱',
            keywords: '划一划游戏,数钞票游戏,酒吧霸屏软件,酒吧互动软件',
            description: '经典划一划数钞票游戏，参与便捷，玩法有趣，就在松鼠互娱酒吧霸屏互动点歌软件',
          },
        },
      },
      {
        path: 'mobileRemote',
        name: 'MobileRemote',
        component: () => import('../views/HelpView/helps/mobileRemote.vue'),
        prerender: true,
        meta: {
          tdk: {
            title: '手机遥控本场活动_松鼠互娱',
            keywords:
              '手机遥控器,微信上墙,微信互动,荭包雨,摇一摇,弹幕霸屏,抽奖软件,扫码签到软件,酒吧霸屏软件,酒吧互动软件',
            description:
              '松鼠互娱是专业的酒吧霸屏大屏互动点歌软件，更提供手机遥控器功能，极大便利酒吧管理员操作遥控设置本场活动，控制互动游戏进程，让活动更精彩。',
          },
        },
      },
    ],
  },
  {
    path: '/mobile',
    name: 'MobileView',
    component: () => import('../views/MobileView/MobileView.vue'),
    meta: {
      showHeader: false,
      showFooter: false,
    },
  },
];
